export default __webpack_public_path__ + "static/media/enquiry-icon.4c19633c.png";